// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"b3722fa5","338":"5aa594b4","411":"7bd3bd5c","486":"78e43202","544":"27b231b1","574":"7c7fa76c","576":"8b0d0c1e","582":"447c7fc6","753":"abf22371","775":"5eb310bf","823":"fe8a2f38","911":"aeaf516e","986":"9ba9753e","990":"13d864e1"}[chunkId] + ".js";
};